import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';

// components

import { Table } from 'app-components';

// types

import type { AgentResultDetails } from '../useAgentListing';

// props
interface AgentSearchResultsProps {
    isShowZipResults: boolean;
    data: AgentResultDetails[]
}

const DEFAULT_AVATAR = global.__ENV__.PRODUCTION ? '/hix/resources/img/simple-avatar.png' : '/assets/images/simple-avatar.png';

function AgentSearchResultsContainer(props: AgentSearchResultsProps) {

    const { isShowZipResults, data } = props;
    const { pathname } = useLocation(); 

    const renderContactInfo = (item) => {
        const {
            brokerId,
            firstName,
            lastName,
            businessName,
            location: {
                address1,
                city,
                state,
                zip
            },
            contactNumber,
            yourPublicEmail,
        } = item;

        return (
            <>
                <span>
                    <Link to={{ pathname: `${pathname}/${brokerId}`, state: {
                        ...item
                    } }}>
                        {firstName} {lastName}
                    </Link>
                </span>
                <span>{businessName}</span>
                <span>{address1} {city} {state} {zip}</span>
                <span>{contactNumber} {yourPublicEmail}</span>
            </>
        );
    };

    const showDefaultAvatar = (ev) => {
        ev.target.src = DEFAULT_AVATAR;
    };

    const renderLogo = (item) => <img src={item.profilePhotoUrl || DEFAULT_AVATAR} style={{ width: '150px' }} alt={item.contactNumber} onError={showDefaultAvatar}/>;

    const renderDistance = (item) => <span>{ parseFloat(item.distance).toFixed(1) } <FormattedMessage id='ga.search.miles' /></span>;

    const zipColumns = [
        {
            titleId: 'ga.agents.results.header.logo_col',
            key: 'profilePhotoUrl',
            render: renderLogo
        },
        {
            titleId: 'ga.agents.results.header.contact_info',
            key: 'businessName',
            render: renderContactInfo
        },
        {
            titleId: 'ga.agents.results.header.distance',
            key: 'distance',
            render: renderDistance
        },
        {
            titleId: 'ga.agents.results.header.languages',
            key: 'languagesSpoken'
        },
        {
            titleId: 'ga.agents.results.header.products',
            key: 'productExpertise'
        }
    ];

    const nameColumns = [
        {
            titleId: 'ga.agents.results.header.logo_col',
            key: 'profilePhotoUrl',
            render: renderLogo
        },
        {
            titleId: 'ga.agents.results.header.contact_info',
            key: 'businessName',
            render: renderContactInfo
        },
        {
            titleId: 'ga.agents.results.header.languages',
            key: 'languagesSpoken'
        },
        {
            titleId: 'ga.agents.results.header.products',
            key: 'productExpertise'
        }
    ];

    const columns = isShowZipResults ? zipColumns : nameColumns;

    return (
        <>
            {
                data &&
                <Table columns={columns} data={data} />
            }
        </>
    );
}

export default AgentSearchResultsContainer;